/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        var ApPageMenu = /** @class */ (function () {
            function ApPageMenu() {
                this.replace = false;
                this.restrict = 'A';
                this.scope = {};
                this.templateUrl = 'app/directives/ap-page-menu/template.html';
                this.controller = Directives.ApPageMenuController;
                this.controllerAs = 'ctrl';
            }
            ApPageMenu.factory = function () {
                var directive = function () {
                    return new ApPageMenu();
                };
                directive['$inject'] = [];
                return directive;
            };
            return ApPageMenu;
        }());
        angular
            .module('app.Directives')
            .directive('apPageMenu', ApPageMenu.factory());
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
